(() => {
  'use strict';

  if (window.__anatomyReviewsHeaderInit) return;
  window.__anatomyReviewsHeaderInit = true;

  const observers = new Set();

  const run = () => {
    if (!document.body.classList.contains('template-index')) return;

    const legacyTerms = [
      ['Aminalyl', 'S'].join('-'),
      ['Pro', 'Amino', 'X'].join('-'),
      ['Pro-Amino', 'X'].join(' '),
      ['Pro Amino', 'X'].join(' '),
      ['Trialyl', 'S'].join('-')
    ];
    const legacyPattern = new RegExp(legacyTerms.map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'i');
    const reviewCardSelector = '.oke-reviewCarousel-reviews-review, .oke-review, .oke-w-review';

    const removeLegacyReviewCards = () => {
      document.querySelectorAll(reviewCardSelector).forEach((card) => {
        if (legacyPattern.test(card.textContent || '')) card.remove();
      });
    };

    removeLegacyReviewCards();

    const observer = new MutationObserver(removeLegacyReviewCards);
    observer.observe(document.body, { childList: true, subtree: true });
    observers.add(observer);
    window.setTimeout(() => {
      observer.disconnect();
      observers.delete(observer);
    }, 15000);
  };

  const disconnectAll = () => {
    observers.forEach((observer) => observer.disconnect());
    observers.clear();
  };

  run();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.querySelector && !event.target.querySelector('[data-anatomy-reviews-header]')) return;
    run();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target && event.target.querySelector && !event.target.querySelector('[data-anatomy-reviews-header]')) return;
    disconnectAll();
  });
})();
